import { connect } from 'react-redux';
import ReportDataTable from '../components/reports/PerGroupReport';

const mapStateToProps = (state, ownProps) => ({
  data: state.reports.perGroupReport,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportDataTable);
